import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 设置默认标题
document.title = localStorage.getItem('username') ? `${localStorage.getItem('username')}的博客` : 'x-shuffle'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 